import React from "react";
import { LegalLayout } from "../components/LegalLayout";

export default function PrivacyPage() {
  return <LegalLayout pageKey="privacy" accent="cyan" />;
}
